<template>
  <div
    class="col-lg-12 ctr_trm"
    @copy.prevent
    @cut.prevent
    @selectstart.prevent
  >
    <p class="p1 subtitle">PT Digital Kripto Indonesia</p>
    <p class="p1">
      Syarat dan Ketentuan ini (" Syarat dan Ketentuan ") merupakan kontrak
      antara anda (selanjutnya disebut sebagai " anda " atau " milik anda ") dan
      Pegasus Exchange (sebagaimana dijelaskan di bawah ini).
    </p>
    <p class="p1">
      PT Digital Kripto Indonesia adalah perusahaan dengan kantor terdaftar di
      AXA Tower Lt 37 Suite (6), Kuningan city, Axa Tower, Jl. Prof. DR. Satrio,
      RT.14/RW.4, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta
      Selatan, Daerah Khusus Ibukota Jakarta 12940 dan merupakan suatu
      perusahaan yang didirikan berdasarkan hukum Negara Republik Indonesia ("
      Pegasus Exchange ").
    </p>
    <p class="p1">
      Berdasarkan peraturan perundang-undangan yang berlaku, termasuk Peraturan
      Otoritas Jasa Keuangan ("OJK") No. 27 tahun 2024 dan Peraturan Otoritas
      Jasa Keuangan ("OJK") No. 23 tahun 2025 tentang Penyelenggaraan
      Perdagangan Aset Keuangan Digital Termasuk Aset Kripto serta Peraturan OJK
      No. 22 tahun 2023 tentang Pelindungan Konsumen dan Masyarakat di Sektor
      Jasa Keuangan ("POJK Pelindungan Konsumen"); yang mengatur mengenai
      Penggunaan jasa, teknologi, produk, Application Programming Interface
      (API), dan layanan lainnya sebagaimana tersedia untuk Anda melalui
      Platform Pegasus Exchange dan diatur lebih lanjut melalui Syarat dan
      Ketentuan ini.
    </p>
    <p class="p1">
      Dengan mengakses, mengunduh, menggunakan, mendaftar untuk sebuah akun dan
      mengeklik " Saya setuju ", anda dengan ini menerima Layanan Pegasus
      Exchange (sebagaimana didefinisikan di bawah) yang disediakan oleh Pegasus
      Exchange Indonesia. Anda setuju bahwa anda telah membaca, memahami, dan
      menerima semua Syarat dan Ketentuan yang ditetapkan dalam ini, serta
      Kebijakan Privasi kami di
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >. Selain itu, saat menggunakan beberapa fitur Layanan, Anda mungkin
      tunduk pada syarat dan ketentuan tambahan khusus yang berlaku untuk fitur
      tersebut.
    </p>
    <p class="p1">
      Harap membaca Syarat dan Ketentuan ini dengan cermat karena ketentuan
      tersebut mengatur Penggunaan anda atas Layanan Pegasus Exchange.
    </p>
    <h1 class="text_h">I. Definisi</h1>
    <p class="p1">
      Auto-Invest berarti fungsi yang memungkinkan Konsumen untuk
      mengotomatisasi investasi Aset Keuangan Digital untuk mendapatkan
      pendapatan pasif.
    </p>
    <p class="p1">
      Pegasus Exchange berarti sebagai definisi yang diberikan dalam bagian
      Pembukaan yang terdapat di atas.
    </p>
    <p class="p1">
      Akun Pegasus Exchange berarti akun Konsumen yang dibuat baik untuk
      menerima Layanan Pegasus Exchange yang disediakan kami.
    </p>
    <p class="p1">
      Platform Pegasus Exchange berarti platform di mana Pegasus Exchange akan
      menyediakan layanannya kepada Konsumen. Platform ini dapat berupa situs
      web Pegasus Exchange dan aplikasinya.
    </p>
    <p class="p1">
      Layanan Pegasus Exchange berarti berbagai layanan yang diberikan kepada
      anda oleh Pegasus Exchange yang didasarkan pada teknologi internet
      dan/atau teknologi blockchain dan ditawarkan melalui situs web Pegasus
      Exchange, aplikasi seluler, dan bentuk lainnya (termasuk bentuk-bentuk
      baru yang akan dimungkinkan oleh perkembangan teknologi di masa depan).
      Layanan Pegasus Exchange termasuk tetapi tidak terbatas pada Platform
      Perdagangan Aset Keuangan Digital dan layanan baru yang akan disediakan
      oleh Pegasus Exchange.
    </p>
    <p class="p1">
      Koin berarti salah satu bentuk Aset Keuangan Digital yang memiliki
      konfigurasi blockchain tersendiri dan memiliki karakteristik seperti Aset
      Keuangan Digital yang muncul pertama kali yaitu bitcoin.
    </p>
    <p class="p1">
      Aset Keuangan Digital berarti komoditas yang tidak berwujud dalam bentuk
      digital dan menggunakan kriptografi, jaringan teknologi informasi, dan
      buku besar yang terdistribusi, untuk mengatur penciptaan unit baru,
      memverifikasi Transaksi, dan mengamankan Transaksi tanpa campur tangan
      pihak lain.
    </p>
    <p class="p1">
      Setoran Fiat berarti Aset Keuangan Digital di mana Konsumen dapat
      mengkredit akun mereka melalui transfer bank. Setoran tersebut akan
      memungkinkan Konsumen untuk membayar pembelian dan membeli Aset Keuangan
      Digital.
    </p>
    <p class="p1">
      Penarikan Fiat berarti penjualan Aset Keuangan Digital berdasarkan harga
      pasar spot.
    </p>
    <p class="p1">
      KYC berarti proses "Know-Your-Customer" yang telah dilakukan oleh Pegasus
      Exchange sebelum menjalankan hubungan bisnis atau melakukan Transaksi
      dengan Konsumen. Sebagai bagian dari proses ini, Pegasus Exchange dapat
      melakukan apa pun yang dianggap perlu untuk mengidentifikasi Konsumen,
      melakukan proses verifikasi atas identitas Konsumen, meneliti dan
      menyelidiki Transaksi Konsumen, untuk mematuhi hukum dan peraturan
      perundang-undangan yang berlaku.
    </p>
    <p class="p1">
      Informasi Rahasia berarti informasi atau data yang diberikan oleh Konsumen
      kepada Pegasus Exchange untuk melaksanakan Syarat dan Ketentuan ini.
    </p>
    <p class="p1">
      Daftar Aset Keuangan Digital yang Diperdagangkan berarti daftar Aset
      Keuangan Digital yang diperdagangkan oleh Konsumen yang tersedia di
      Platform Pegasus Exchange.
    </p>
    <p class="p1">
      Pesanan (Order) berarti suatu instruksi dari Konsumen untuk Penggunaan
      Layanan Pegasus Exchange terkait dengan Perdagangan Crypto-to-crypto.
    </p>
    <p class="p1">
      Dokumen Pemberitahuan dan Pernyataan Risiko berarti pernyataan dan/atau
      dokumen dari Pegasus Exchange yang menguraikan informasi mengenai risiko
      fluktuasi harga, kegagalan sistem dan risiko terkait lainnya, yang
      diberikan kepada Konsumen.
    </p>
    <p class="p1">
      Buku Order (Order Book) berarti daftar Pesanan (Order) beli dan jual yang
      saat ini terbuka untuk suatu aset, disusun berdasarkan harga.
    </p>
    <p class="p1">
      Informasi Pribadi berarti informasi dan/atau data pribadi yang akan
      dikumpulkan oleh Pegasus Exchange dari Konsumen dalam Penggunaan Layanan
      Pegasus Exchange.
    </p>
    <p class="p1">
      Perdagangan Spot berarti fasilitas perdagangan yang disediakan oleh
      Pegasus Exchange untuk melakukan perdagangan dengan Konsumen lain di pasar
      melalui Buku Order (Order Book), pada harga pasar saat ini.
    </p>
    <p class="p1">
      Token berarti salah satu bentuk Aset Keuangan Digital yang dibuat sebagai
      produk turunan dari Koin.
    </p>
    <p class="p1">
      Transaksi berarti proses perdagangan Aset Keuangan Digital oleh Konsumen
      di Platform Pegasus Exchange.
    </p>
    <p class="p1">
      Perjanjian Pelanggan berarti suatu perjanjian antara Pegasus Exchange dan
      Konsumennya, di mana harus disetujui oleh Konsumen tersebut untuk
      mengakses Layanan Pegasus Exchange .
    </p>
    <p class="p1">
      Konsumen berarti semua individu yang mengakses, mengunduh, atau
      menggunakan Layanan Pegasus Exchange dan yang memenuhi kriteria dan
      ketentuan kelayakan yang ditetapkan oleh Pegasus Exchange serta hukum dan
      peraturan perundang-undangan yang berlaku.
    </p>
    <p class="p1">
      Dompet (Wallet) berarti media yang dipergunakan untuk menyimpan Aset
      Keuangan Digital baik berupa Koin atau Token.
    </p>
    <h1 class="text_h">II. Ketentuan Umum</h1>
    <h2 class="text_h">1. Tentang Syarat dan Ketentuan Ini</h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Hubungan Kontrak
      </li>
    </ul>
    <p class="p1">
      Ketentuan ini merupakan perjanjian hukum dan menciptakan kontrak yang
      mengikat antara anda dan Pegasus Exchange.
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Suplemen dan Tambahan terhadap Syarat
        dan Ketentuan ini
      </li>
    </ul>
    <p class="p1">
      Disebabkan oleh perkembangan pesat Aset Keuangan Digital dan Pegasus
      Exchange, Syarat dan Ketentuan antara anda dan Pegasus Exchange ini tidak
      menghitung atau mencakup semua hak dan kewajiban masing-masing pihak, dan
      tidak menjamin keselarasan penuh dengan kebutuhan yang timbul dari
      pengembangan di masa depan.
    </p>
    <p class="p1">
      Khusus untuk privasi data dan perlindungan Informasi Pribadi, anda
      dipersilahkan untuk mengacu kepada Kebijakan Privasi kami, yang dapat
      diakses di
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
    </p>
    <p class="p1">
      Semua perjanjian lain yang dibuat secara terpisah antara anda dan Pegasus
      Exchange akan dianggap sebagai pelengkap dan merupakan bagian yang
      integral dan tidak terpisahkan dari Syarat dan Ketentuan ini dan akan
      memiliki akibat hukum yang sama, termasuk Perjanjian Pelanggan.
    </p>
    <p class="p1">
      Pegasus Exchange berhak untuk mengubah atau memodifikasi Syarat dan
      Ketentuan ini atas kebijakannya setiap saat. Pegasus Exchange akan
      memberitahukan perubahan tersebut dengan memperbarui ketentuan di situs
      webnya
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      dan mengubah tanggal "Revisi terakhir" yang ditampilkan di halaman ini.
    </p>
    <h2 class="text_h">2. Tentang Pegasus Exchange</h2>
    <p class="p1">
      Kegiatan perdagangan Aset Keuangan Digital dilakukan oleh Pegasus Exchange
      Indonesia, suatu perusahaan Pedagang Aset Keuangan Digital yang berizin
      dan diawasi oleh OJK serta merupakan anggota Indonesia Crypto Exchange
      (ICEX) dan Crypto Asset Clearing Indonesia (CACI).
    </p>
    <h2 class="text_h">3. Pendaftaran dan Persyaratan Akun</h2>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">a.</span> Pendaftaran</li>
    </ul>
    <p class="p1">
      Semua Konsumen wajib mendaftar dan mendapatkan Akun Pegasus Exchange dari
      dan hanya melalui
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      sebelum menggunakan Layanan Pegasus Exchange Indonesia. Ketika anda
      mendaftarkan Akun Pegasus Exchange, anda wajib memberikan informasi yang
      disebutkan dalam Bagian 3 ini atau seperti yang diminta oleh Pegasus
      Exchange, dan menerima Syarat dan Ketentuan, Kebijakan Privasi, serta
      dokumen Pegasus Exchange lainnya. Pegasus Exchange dapat menolak, atas
      kebijakannya sendiri, untuk membuka Akun Pegasus Exchange untuk anda.
    </p>
    <p class="p1">
      Anda setuju untuk memberikan informasi yang lengkap dan akurat saat
      membuka Akun Pegasus Exchange, dan setuju untuk memperbarui secara tepat
      waktu setiap informasi yang anda berikan kepada Pegasus Exchange untuk
      menjaga integritas dan ketepatan informasi. Setiap Konsumen hanya dapat
      memelihara satu akun utama pada waktu tertentu. Pendaftaran, Penggunaan,
      perlindungan, dan pengelolaan akun perdagangan tersebut sama-sama diatur
      oleh ketentuan Syarat dan Ketentuan ini, kecuali dinyatakan lain dalam
      Syarat dan Ketentuan ini atau dalam Kebijakan Privasi.
    </p>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">b.</span> Kelayakan</li>
    </ul>
    <p class="p1">
      Dengan mendaftar untuk menggunakan Akun Pegasus Exchange, anda menyatakan
      dan menjamin bahwa:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">
        sebagai individu, anda setidaknya berusia diatas 17 tahun atau cukup
        umur untuk membuat kontrak yang sah dan mengikat berdasarkan hukum dan
        peraturan perundang-undangan yang berlaku;
      </li>
      <li class="li-sub">
        sebagai individu, anda memiliki kapasitas yang penuh untuk mengikat diri
        secara hukum dalam Syarat dan Ketentuan ini;
      </li>
      <li class="li-sub">
        memiliki Kartu Tanda Penduduk bagi warga negara Indonesia, atau paspor
        dan kartu identitas yang diterbitkan oleh negara asal atau Kartu Izin
        Tinggal Terbatas (KITAS) bagi warga negara asing;
      </li>
      <li class="li-sub">
        anda belum pernah dihentikan atau dihapus dari Penggunaan anda atas
        Platform atau Layanan Pegasus Exchange;
      </li>
      <li class="li-sub">anda belum pernah memiliki Akun Pegasus Exchange;</li>
      <li class="li-sub">
        anda bukan penduduk, berlokasi atau berdomisili di atau mencoba
        mengakses Platform atau Layanan Pegasus Exchange dari Lokasi Terbatas.
        Untuk tujuan perjanjian ini, " Lokasi Terbatas " akan mencakup lokasi
        lainnya seperti yang ditunjuk oleh Pegasus Exchange dari waktu ke waktu
        sebagai "Lokasi Terbatas" untuk tujuan ini;
      </li>
      <li class="li-sub">
        Penggunaan anda atas Platform dan Layanan Pegasus Exchange tidak akan
        melanggar setiap dan semua hukum dan peraturan perundang-undangan yang
        berlaku bagi anda, termasuk namun tidak terbatas pada peraturan tentang
        anti pencucian uang, anti penyuapan dan pendanaan terorisme serta
        proliferasi senjata pemusnah massal.
      </li>
    </ul>
    <p class="p1">
      Harap dicatat bahwa ada persyaratan hukum di berbagai negara yang dapat
      membatasi Layanan yang dapat disediakan oleh Pegasus Exchange secara sah.
      Oleh karena itu, beberapa produk dan layanan dan fungsionalitas tertentu
      dalam Platform Pegasus Exchange mungkin tidak tersedia atau mungkin
      dibatasi di yurisdiksi atau wilayah tertentu atau untuk Konsumen tertentu.
    </p>
    <p class="p1">
      Anda bertanggung jawab untuk menginformasikan diri anda sendiri dan
      mematuhi segala batasan dan/atau persyaratan yang diberlakukan sehubungan
      dengan akses ke dan Penggunaan Platform dan Layanan Pegasus Exchange.
      Pegasus Exchange berhak untuk mengubah, memodifikasi atau memberlakukan
      batasan tambahan sehubungan dengan akses ke dan Penggunaan Platform dan
      Layanan Pegasus Exchange dari waktu ke waktu atas kebijakan mereka setiap
      saat tanpa pemberitahuan sebelumnya.
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Verifikasi Identitas Konsumen
      </li>
    </ul>
    <p class="p1">
      Pendaftaran akun anda dengan Pegasus Exchange akan dianggap sebagai
      persetujuan anda untuk memberikan Informasi Pribadi yang diperlukan untuk
      kepentingan verifikasi identitas. Informasi tersebut akan digunakan untuk
      memverifikasi identitas Konsumen, mengidentifikasi jejak pencucian uang,
      pendanaan terorisme, penipuan dan kejahatan keuangan lainnya melalui
      Pegasus Exchange, atau untuk tujuan sah lainnya yang dinyatakan oleh
      Pegasus Exchange. Kami akan mengumpulkan, menggunakan, dan membagikan
      informasi tersebut sesuai dengan Kebijakan Privasi kami.
    </p>
    <p class="p1">
      Selain memberikan informasi yang terkait, anda setuju untuk mengizinkan
      kami menyimpan catatan informasi tersebut selama periode akun anda aktif
      dan dalam waktu lima (5) tahun setelah akun anda ditutup, sesuai dengan
      standar industri global tentang penyimpanan data, dan hukum dan peraturan
      perundang-undangan yang berlaku. Anda juga memberikan wewenang kepada kami
      untuk melakukan penyelidikan yang diperlukan secara langsung atau melalui
      pihak ketiga untuk memverifikasi identitas anda atau melindungi Anda
      dan/atau kami dari kejahatan keuangan, seperti penipuan. Informasi yang
      kami perlukan untuk memverifikasi identitas anda dapat mencakup, namun
      tidak terbatas pada, nama anda, alamat email, informasi kontak, nomor
      telepon, nama Konsumen, tanda pengenal/identitas yang dikeluarkan
      pemerintah, tanggal lahir, dan informasi lain yang dikumpulkan selama
      pendaftaran akun. Pegasus Exchange juga akan menggunakan teknologi yang
      mencakup facial recognition dengan fitur liveness, yang terintegrasi
      dengan data biometrik untuk melakukan verifikasi identitas Konsumen. Saat
      memberikan informasi yang diperlukan, anda mengonfirmasi bahwa informasi
      dan data tersebut benar dan akurat.
    </p>
    <p class="p1">
      Setelah pendaftaran, anda wajib memastikan bahwa informasi yang anda
      berikan merupakan informasi yang benar dan lengkap, serta diperbaharui
      saat mengalami perubahan. Apabila terdapat alasan untuk meyakini bahwa
      informasi yang anda berikan tidak benar, salah, kedaluwarsa, atau tidak
      lengkap, Pegasus Exchange berhak untuk mengirimkan pemberitahuan kepada
      anda untuk meminta koreksi, langsung menghapus informasi yang relevan,
      dan, apabila mungkin, mengakhiri semua atau sebagian dari Layanan Pegasus
      Exchange yang kami sediakan untuk anda.
    </p>
    <p class="p1">
      Apabila kami tidak dapat menghubungi anda dengan informasi kontak yang
      anda berikan, anda bertanggung jawab penuh atas segala kerugian atau
      pengeluaran yang disebabkan oleh Pegasus Exchange selama anda menggunakan
      Layanan Pegasus Exchange. Anda dengan ini mengakui dan setuju bahwa anda
      memiliki kewajiban untuk memperbarui semua informasi apabila terdapat
      perubahan.
    </p>
    <p class="p1">
      Dengan mendaftarkan akun, anda dengan ini memberikan wewenang kepada
      Pegasus Exchange untuk melakukan penyelidikan yang dianggap perlu oleh
      Pegasus Exchange Indonesia, baik secara langsung maupun melalui pihak
      ketiga, untuk memverifikasi identitas anda atau melindungi anda dan
      Konsumen lain dan/atau Pegasus Exchange dari penipuan atau kejahatan
      keuangan lainnya, dan untuk mengambil tindakan yang diperlukan berdasarkan
      hasil penyelidikan tersebut. Anda juga mengakui dan setuju bahwa Informasi
      Pribadi anda dapat diungkapkan kepada instansi pemerintah yang terkait
      untuk pencegahan penipuan atau pencegahan kejahatan keuangan, yang dapat
      menanggapi penyelidikan kami secara penuh.
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Persyaratan Akun Konsumen
      </li>
    </ul>
    <p class="p1">
      Akun Pegasus Exchange anda hanya dapat digunakan oleh anda sebagai
      pendaftar akun. Pegasus Exchange berhak untuk menangguhkan, membekukan
      atau membatalkan Penggunaan Akun Pegasus Exchange oleh orang selain
      pendaftar akun. Jika anda mencurigai atau mengetahui adanya Penggunaan
      yang tidak sah atas username dan kata sandi terdaftar anda, anda harus
      segera memberi tahu Pegasus Exchange Indonesia. Pegasus Exchange tidak
      bertanggung jawab atas kehilangan atau kerusakan yang timbul dari
      Penggunaan Akun Pegasus Exchange oleh anda atau pihak ketiga dengan atau
      tanpa otorisasi dan persetujuan anda.
    </p>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">e.</span> Keamanan Akun</li>
    </ul>
    <p class="p1">
      Pegasus Exchange telah berkomitmen untuk menjaga keamanan dana dari
      Konsumen, dan telah menerapkan perlindungan standar industri terhadap
      Layanan Pegasus Exchange Indonesia. Namun, tindakan masing-masing Konsumen
      dapat menimbulkan risiko. Anda harus setuju untuk memperlakukan kredensial
      akses anda (seperti username dan kata sandi) sebagai Informasi Rahasia,
      dan tidak mengungkapkan informasi tersebut kepada pihak ketiga mana pun.
      Anda juga setuju untuk bertanggung jawab penuh untuk mengambil
      langkah-langkah keamanan yang diperlukan untuk melindungi Akun Pegasus
      Exchange dan Informasi Pribadi anda.
    </p>
    <p class="p1">
      Dengan membuat Akun Pegasus Exchange Indonesia, anda setuju bahwa:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">
        anda akan segera memberi tahu Pegasus Exchange jika anda mengetahui
        adanya Penggunaan yang tidak sah atas kata sandi dan Akun Pegasus
        Exchange anda atau pelanggaran aturan keamanan lainnya;
      </li>
      <li class="li-sub">
        anda akan secara ketat mematuhi semua mekanisme atau prosedur Pegasus
        Exchange mengenai keamanan, autentikasi, perdagangan, pengisian, dan
        penarikan; dan
      </li>
      <li class="li-sub">
        anda akan mengambil langkah-langkah yang tepat untuk logout dari Akun
        Pegasus Exchange anda di akhir setiap kunjungan.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">f.</span> Larangan Penggunaan
      </li>
    </ul>
    <p class="p1">
      Melalui Penggunaan Layanan Pegasus Exchange, anda menyatakan dan menjamin
      bahwa anda tidak termasuk di dalam suatu Daftar Sanksi Ekonomi dan/atau
      Keuangan, Embargo Perdagangan, dan persyaratan lain dari hukum dan
      peraturan perundang-undangan yang berlaku.
    </p>
    <p class="p1">
      Pegasus Exchange berhak untuk memilih pasar dan yurisdiksi untuk
      menjalankan bisnisnya, dan dapat membatasi atau menolak, atas kebijakannya
      sendiri, penyediaan Layanan Pegasus Exchange ke negara atau wilayah
      tertentu.
    </p>
    <h1 class="text_h">III. Layanan-layanan Pegasus Exchange Indonesia</h1>
    <p class="p1">
      Setelah pendaftaran dan pembuatan Akun Pegasus Exchange anda, anda akan
      memiliki akses kepada Layanan Pegasus Exchange berikut:
    </p>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">a.</span> Setoran Fiat</li>
    </ul>
    <p class="p1">
      Agar Konsumen dapat membeli Aset Keuangan Digital, Konsumen dapat
      mengkredit Akun Pegasus Exchange melalui transfer bank. Setelah itu,
      Konsumen dapat menggunakan saldo akun mereka untuk membayar pembelian Aset
      Keuangan Digital, dan Aset Keuangan Digital yang dibeli akan langsung
      dikreditkan ke akun Konsumen.
    </p>
    <p class="p1">
      Setelah deposit selesai, Konsumen dapat menggunakan saldo fiat untuk
      membeli Aset Keuangan Digital.
    </p>
    <p class="p1">
      Setoran Fiat (yang dilakukan melalui transfer bank) akan muncul di Dompet
      (Wallet) Spot Konsumen sesuai dengan mata uang yang mereka setorkan.
    </p>
    <p class="p1">Setoran Fiat dapat dilakukan melalui hal-hal berikut:</p>
    <ul class="ul-sub">
      <li class="li-sub">
        Setoran Bank: Setoran akan dilakukan melalui saluran perbankan, didukung
        oleh penyedia layanan pembayaran.
      </li>
      <li class="li-sub">
        Setoran Dompet (Wallet) Elektronik: Setoran akan dilakukan melalui
        Dompet (Wallet) elektronik, yang didukung oleh penyedia layanan
        pembayaran.
      </li>
    </ul>
    <p class="p1">
      Layanan Setoran Fiat melibatkan penyediaan layanan pertukaran antara mata
      uang fiat dan Aset Keuangan Digital dan penyediaan layanan Dompet (Wallet)
      kustodian.
    </p>
    <p class="p1">
      Pegasus Exchange akan menahan dana Fiat Konsumen setelah diterima. Pegasus
      Exchange akan bertindak sebagai rekanan utama untuk Transaksi tersebut,
      menggunakan cadangan Aset Keuangan Digital miliknya sendiri untuk
      menyelesaikan semua pembelian. Dalam layanan ini, Konsumen tidak akan
      membeli Aset Keuangan Digital secara peer-to-peer, melainkan Pegasus
      Exchange akan menjadi rekanan (counterparty) untuk setiap Transaksi.
    </p>
    <ul class="ul-letter">
      <li class="li-letter"><span class="li-label">b.</span> Penarikan Fiat</li>
    </ul>
    <p class="p1">
      Berbeda dengan pembelian Aset Keuangan Digital, Konsumen mungkin ingin
      menjual Aset Keuangan Digital mereka langsung ke Pegasus Exchange
      Indonesia. Dalam keadaan seperti itu, Pegasus Exchange akan membeli
      aset-aset ini dengan harga yang dapat dieksekusi (yang akan didasarkan
      pada harga pasar spot).
    </p>
    <p class="p1">
      Dalam kedua kasus tersebut, Pegasus Exchange akan bertindak sebagai
      rekanan utama untuk Transaksi tersebut, menggunakan cadangan mata uang
      fiatnya sendiri untuk menyelesaikan semua Pesanan (Order) penjualan ini.
      Dalam Layanan ini, Konsumen tidak akan menjual Aset Keuangan Digital
      secara peer-to-peer. Pegasus Exchange akan menjadi rekanan (counterparty)
      untuk setiap Transaksi.
    </p>
    <p class="p1">
      Setelah berhasil menyelesaikan Pesanan (Order) jual, saldo fiat akan
      terlihat di Dompet (Wallet) Spot yang dimiliki Konsumen, Konsumen tersebut
      dapat melakukan penarikan fiat ke rekening bank mereka sendiri. Penarikan
      oleh Konsumen akan didukung oleh penyedia layanan pembayaran yang berupa
      pihak ketiga.
    </p>
    <p class="p1">
      Layanan Penarikan Fiat sebagaimana dijelaskan di atas melibatkan
      penyediaan layanan perdagangan antara Aset Keuangan Digital dan fiat, dan
      penyediaan layanan Dompet (Wallet) kustodian. Selanjutnya, Pegasus
      Exchange akan menahan dana Fiat yang dimiliki Konsumen setelah Pesanan
      (Order) penjualan berhasil dijalankan. Pegasus Exchange akan bertindak
      sebagai rekanan utama untuk Transaksi tersebut, menggunakan cadangan
      fiatnya sendiri untuk menyelesaikan semua penjualan. Dalam Layanan ini,
      Konsumen tidak akan menjual Aset Keuangan Digital secara peer-to-peer,
      tetapi Pegasus Exchange akan menjadi rekanan (counterparty) untuk setiap
      Transaksi.
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Perdagangan Spot
      </li>
    </ul>
    <p class="p1">
      Perdagangan Spot memungkinkan Konsumen untuk mengakses fasilitas
      perdagangan yang berdagang dengan Konsumen lain di pasar melalui Buku
      Order (Order Book) pada kurs pasar saat ini (juga dikenal sebagai harga
      spot). Perdagangan tersebut akan terjadi segera ketika pesanan telah
      dipenuhi.
    </p>
    <p class="p1">
      Konsumen dapat mengirimkan Pesanan (Order) beli atau jual untuk salah satu
      pasangan perdagangan yang tersedia. Jika Pesanan (Order) divalidasi oleh
      Pegasus Exchange Indonesia, maka Pesanan (Order) Konsumen akan ditambahkan
      ke Buku Order (Order Book). Kemudian, Pesanan (Order) tersebut dapat
      dicocokkan dengan Pesanan (Order) lain yang memenuhi aturan pencocokan.
      Pegasus Exchange akan membebankan biaya Transaksi ke semua Pesanan (Order)
      setelah dicocokkan dan diperdagangkan. Penyelesaian perdagangan akan
      terjadi dengan sistem akuntansi internal yang dimiliki Platform Pegasus
      Exchange Indonesia.
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Dompet (Wallet) Spot
      </li>
    </ul>
    <p class="p1">
      Dompet (Wallet) Spot adalah Dompet (Wallet) Konsumen dalam platform
      Pegasus Exchange untuk menampung Aset Keuangan Digital dimilikinya yang
      dibeli melalui Platform Pegasus Exchange dan/atau Aset Keuangan Digital
      yang dikirim ke dalam Dompet (Wallet) ini dari Dompet (Wallet) eksternal
      Konsumen.
    </p>
    <h1 class="text_h">IV. Pedoman Layanan Pegasus Exchange Indonesia</h1>
    <h2 class="text_h">1. Pembatasan</h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Saat anda menggunakan Layanan Pegasus
        Exchange, anda setuju dan berjanji untuk mematuhi ketentuan berikut:
      </li>
    </ul>
    <ul class="ul-sub">
      <li class="li-sub">
        Selama Penggunaan Layanan Pegasus Exchange, semua aktivitas yang anda
        lakukan harus memenuhi persyaratan hukum dan peraturan
        perundang-undangan yang berlaku, Syarat dan Ketentuan ini dan berbagai
        pedoman dari Pegasus Exchange;
      </li>
      <li class="li-sub">
        Penggunaan Layanan Pegasus Exchange oleh anda tidak boleh melanggar
        kepentingan publik, moral publik, atau kepentingan sah milik orang lain,
        termasuk tindakan apa pun yang akan mengganggu, mengacaukan, memengaruhi
        secara negatif, atau melarang Konsumen lain untuk menggunakan Layanan
        Pegasus Exchange;
      </li>
      <li class="li-sub">
        Anda setuju untuk tidak menggunakan Layanan Pegasus Exchange untuk
        kegiatan manipulasi pasar (seperti skema pump and dump, wash trading,
        self-trading, front running, quote stuffing, dan spoofing atau layering,
        terlepas dari adanya atau tidak larangan hukum);
      </li>
      <li class="li-sub">
        Tanpa persetujuan tertulis dari Pegasus Exchange, Penggunaan data
        Pegasus Exchange secara komersial dilarang;
      </li>
      <li class="li-sub">
        Tanpa persetujuan tertulis terlebih dahulu dari Layanan Pegasus
        Exchange, anda tidak boleh memodifikasi, mereplika, menggadakan,
        menyalin, mengunduh, menyimpan, mengirimkan, menyebarkan, mentransfer,
        membongkar, menyiarkan, menerbitkan, menghapus atau mengubah pernyataan
        atau label hak cipta, atau lisensi apa pun, mensublisensikan, menjual,
        meniru, mendesain, menyewakan, memberi label pribadi, memberikan hak
        jaminan di properti atau bagian mana pun dari properti, atau membuat
        karya turunannya atau memanfaatkan bagian mana pun dari properti.
      </li>
      <li class="li-sub">
        Anda tidak boleh (i) menggunakan deep linking, web crawlers, bot, spider
        atau perangkat otomatis lainnya, program, scripts, algoritma atau
        metode, atau proses manual yang serupa atau setara untuk mengakses,
        memperoleh, menyalin, atau memantau bagian mana pun dari properti, atau
        mereplika atau melewati struktur navigasi atau presentasi Layanan
        Pegasus Exchange dengan cara apa pun, untuk mendapatkan atau berupaya
        mendapatkan materi, dokumen, atau informasi apa pun dengan cara apa pun
        yang tidak disediakan secara sengaja melalui Layanan Pegasus Exchange;
        (ii) mencoba untuk mengakses bagian atau fungsi apa pun dari properti
        tanpa izin, atau terhubung dengan Layanan Pegasus Exchange atau server
        Pegasus Exchange atau sistem atau jaringan lainnya dari Layanan Pegasus
        Exchange yang disediakan melalui layanan dengan cara hacking, mining
        kata sandi, atau cara lainnya yang tidak sah atau dilarang; (iii)
        menyelidiki, memindai, atau menguji kelemahan Layanan Pegasus Exchange
        atau jaringan apa pun yang terhubung ke properti, atau melanggar
        tindakan keamanan atau autentikasi otentikasi apa pun pada Layanan
        Pegasus Exchange atau jaringan apa pun yang terhubung ke Layanan Pegasus
        Exchange; (iv) membalikkan pencarian, melacak atau mencari untuk melacak
        informasi apa pun dari Konsumen lain atau pengunjung Layanan Pegasus
        Exchange; (v) mengambil tindakan apa pun yang membebankan beban besar
        yang tidak wajar atau tidak proporsional pada infrastruktur sistem atau
        jaringan Layanan Pegasus Exchange atau Pegasus Exchange, atau
        infrastruktur sistem atau jaringan apa pun yang terhubung ke Layanan
        Pegasus Exchange; (vi) menggunakan perangkat, perangkat lunak, atau
        program rutin apa pun untuk mengganggu pengoperasian normal Layanan
        Pegasus Exchange atau Transaksi apa pun di Layanan Pegasus Exchange,
        atau Penggunaan Layanan Pegasus Exchange oleh orang lain; (vii)
        memalsukan header, meniru identitas, atau memanipulasi identifikasi,
        untuk menyamarkan identitas anda atau asal pesan atau transmisi apa pun
        yang anda kirim ke Pegasus Exchange, atau (viii) menggunakan Layanan
        Pegasus Exchange secara ilegal.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Dengan mengakses Layanan Pegasus
        Exchange, anda setuju bahwa Pegasus Exchange berhak untuk menyelidiki
        setiap pelanggaran terhadap Syarat dan Ketentuan ini, secara sepihak
        menentukan apakah anda telah melanggar Syarat dan Ketentuan ini, dan
        mengambil tindakan berdasarkan peraturan yang relevan tanpa persetujuan
        anda atau pemberitahuan sebelumnya. Contoh tindakan tersebut termasuk,
        namun tidak terbatas pada:
      </li>
    </ul>
    <ul class="ul-sub">
      <li class="li-sub">Memblokir dan menutup permintaan Pesanan (Order);</li>
      <li class="li-sub">Membekukan akun anda;</li>
      <li class="li-sub">
        Melaporkan kejadian tersebut kepada pihak yang berwenang; dan
      </li>
      <li class="li-sub">
        Mempublikasikan dugaan pelanggaran dan tindakan yang telah dilakukan.
      </li>
    </ul>
    <h2 class="text_h">2. Pesanan (Order)</h2>
    <p class="p1">
      Setelah mengirimkan instruksi Penggunaan Layanan Pegasus Exchange untuk
      Perdagangan Crypto-to-Crypto (atau Pesanan (Order)), akun anda akan segera
      diperbarui untuk menggambarkan Pesanan (Order) terbuka, dan Pesanan
      (Order) anda akan dimasukkan dalam Buku Order Pegasus Exchange untuk
      dicocokkan kepada Pesanan (Order) Konsumen-Konsumen lainnya. Jika salah
      satu Pesanan (Order) anda sepenuhnya atau sebagiannya cocok dengan Order
      Konsumen lain, Pegasus Exchange akan melakukan Transaksi pertukaran.
      Setelah Transaksi dieksekusi secara penuh, akun anda akan diperbarui untuk
      mencerminkan bahwa Pesanan (Order) telah sepenuhnya dieksekusi dan
      ditutup, atau Pesanan (Order) telah dieksekusi secara sebagian. Pesanan
      (Order) akan tetap mendapat status belum selesai sampai sepenuhnya
      dieksekusi atau dibatalkan. Untuk menyelesaikan Transaksi, anda memberi
      wewenang kepada Pegasus Exchange untuk mengontrol sementara Aset Keuangan
      Digital yang terlibat dalam Transaksi anda.
    </p>
    <h2 class="text_h">
      3. Implementasi Transaksi dan Penyimpanan Aset Keuangan Digital
    </h2>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Pegasus Exchange bermaksud untuk
        menerapkan persyaratan travel rule untuk penerapan Layanan Pegasus
        Exchange.
      </li>
    </ul>
    <p class="p1">
      Sebagaimana diatur dalam hukum dan peraturan perundang-undangan yang
      berlaku, yaitu Peraturan Bappebti No. 8 Tahun 2021 dan POJK 27 tahun 2024
      serta POJK 23 Tahun 2025 tentang Pedoman Penyelenggaraan Perdagangan Pasar
      Fisik Aset Keuangan Digital di Bursa Berjangka, untuk setiap perdagangan
      atau pengalihan Aset Keuangan Digital yang nilainya lebih dari USD1.000
      (seribu Dolar Amerika Serikat, atau setara dengan Rupiah), pengirim
      Transaksi tersebut wajib memberikan deskripsi dan/atau informasi berikut:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">Nama pengirim;</li>
      <li class="li-sub">Alamat Dompet (Wallet) pengirim;</li>
      <li class="li-sub">
        Dokumen identitas seperti Kartu Tanda Penduduk (KTP), Paspor, kartu
        identitas yang dikeluarkan dari negara asal pengirim, Kartu Izin Tinggal
        Tetap (KITAP), atau Kartu Izin Tinggal Terbatas (KITAS);
      </li>
      <li class="li-sub">Alamat pengirim; dan</li>
      <li class="li-sub">Tempat dan tanggal lahir pengirim.</li>
    </ul>
    <p class="p1">
      Selanjutnya, penerima Aset Keuangan Digital yang nilainya di atas USD1.000
      (seribu Dolar Amerika Serikat, atau setara dengan Rupiah) yang akan
      menyimpan Aset Keuangan Digital tersebut di Dompet (Wallet) miliknya (baik
      di Dompet (Wallet) dingin maupun Dompet (Wallet) yang tidak disediakan
      oleh Layanan Pegasus Exchange), pengungkapan informasi berikut akan
      diperlukan:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">nama penerima;</li>
      <li class="li-sub">alamat Dompet (Wallet) penerima; dan</li>
      <li class="li-sub">alamat penerima.</li>
    </ul>
    <p class="p1">
      Jika Pegasus Exchange mengalihkan Aset Keuangan Digital yang bernilai
      kurang dari USD1.000 (seribu Dolar Amerika Serikat, atau setara dalam
      Rupiah), pengungkapan informasi berikut akan diperlukan dari Konsumen:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">nama pengirim;</li>
      <li class="li-sub">alamat Dompet (Wallet) pengirim;</li>
      <li class="li-sub">nama penerima; dan</li>
      <li class="li-sub">alamat Dompet (Wallet) penerima.</li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Pegasus Exchange akan menerapkan sistem
        slippery note yang akan memberitahukan apabila terjadinya pergerakan
        harga Aset Keuangan Digital yang signifikan.
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Pegasus Exchange akan menyimpan Aset
        Keuangan Digital anda di Dompet (Wallet) pribadi anda, yang akan dapat
        diakses melalui Platform Pegasus Exchange Indonesia.
      </li>
    </ul>
    <p class="p1">
      Dompet (Wallet) anda memungkinkan anda untuk mengirim, menerima, dan
      menyimpan Aset Keuangan Digital, dengan memberikan instruksi melalui
      Platform Pegasus Exchange Indonesia.
    </p>
    <p class="p1">
      Dalam situasi apa pun anda tidak boleh menggunakan Dompet (Wallet) untuk
      menyimpan, mengirim, meminta, atau menerima Aset Keuangan Digital dalam
      bentuk apa pun yang tidak kami dukung (walaupun Pegasus Exchange akan
      melakukan upaya yang wajar untuk membantu anda memindahkan atau menjual
      Aset Keuangan Digital yang tidak Pegasus Exchange dukung). Pegasus
      Exchange tidak akan bertanggung jawab atau berkewajiban sehubungan dengan
      upaya apa pun untuk menggunakan Dompet (Wallet) anda untuk Aset Keuangan
      Digital yang tidak kami dukung.
    </p>
    <p class="p1">
      Kami menyimpan privatekey Aset Keuangan Digital dengan aman, yang
      merupakan cara anda dapat menyetujui Transaksi dengan aman. Kami menyimpan
      private key dengan aman dalam kendali kami dalam kombinasi penyimpanan
      online dan offline. Sebagai akibatnya, kami mungkin perlu mengambil
      informasi tertentu dari penyimpanan offline untuk memfasilitasi Transaksi
      sesuai dengan instruksi anda, dan anda mengakui bahwa ini dapat menunda
      inisiasi atau mengkredit Transaksi tersebut.
    </p>
    <p class="p1">
      Anda mengakui dan menerima risiko bahwa protokol perangkat lunak yang
      mendasari Transaksi Aset Keuangan Digital apa pun yang anda simpan di
      Dompet (Wallet) anda dapat berubah. Secara khusus, protokol yang mendasari
      kemungkinan akan mengalami perubahan mendadak dalam aturan operasi, yang
      dapat secara material mempengaruhi nilai, fungsi, dan/atau nama Aset
      Keuangan Digital yang anda simpan di Dompet (Wallet) anda. Jika
      memungkinkan, kami dapat memberi anda pemberitahuan atau peringatan sesuai
      dengan Bagian Pengumuman dan Pemberitahuan dalam Syarat dan Ketentuan ini
      agar anda dapat mempertimbangkan setiap perubahan mendadak yang terjadi.
      Namun, anda bertanggung jawab untuk membuat diri anda sadar, dan
      mempertimbangkan cara menghadapi perubahan yang akan datang. Dalam hal
      terdapat risiko karena perubahan mendadak yang dibuat oleh Pegasus
      Exchange Indonesia, kami mungkin perlu menghentikan sementara operasi
      tanpa memberikan pemberitahuan terlebih dahulu kepada anda.
    </p>
    <h2 class="text_h">4. Pembatalan</h2>
    <p class="p1">
      Untuk Pesanan (Order) yang dilakukan melalui Layanan Pegasus Exchange,
      anda hanya dapat membatalkannya sebelum dicocokkan dengan Pesanan (Order)
      Konsumen lain. Setelah Pesanan (Order) anda dicocokkan dengan Pesanan
      (Order) Konsumen lain,anda tidak dapat mengubah, mencabut atau membatalkan
      otorisasi Pegasus Exchange untuk menyelesaikan Pesanan (Order). Untuk
      Pesanan (Order) yang sebagian cocok, anda dapat membatalkan sebagian dari
      Pesanan (Order) yang tidak cocok kecuali bagian tersebut telah cocok.
      Pegasus Exchange berhak untuk menolak segala permintaan pembatalan terkait
      dengan Pesanan (Order) yang telah anda kirimkan. Jika akun anda tidak
      memiliki jumlah Aset Keuangan Digital yang cukup untuk mengeksekusi suatu
      Pesanan (Order), Pegasus Exchange dapat membatalkan seluruh Pesanan
      (Order) atau melaksanakan sebagian dari Pesanan (Order) dengan jumlah Aset
      Keuangan Digital yang anda miliki di akun anda (dalam setiap kasus, setiap
      biaya terkait Transaksi terutang kepada Pegasus Exchange dipotong).
    </p>
    <h2 class="text_h">5. Biaya</h2>
    <p class="p1">
      Anda setuju untuk membayar Pegasus Exchange biaya yang ditentukan dalam
      Aturan Perdagangan (Trading Rules). Pegasus Exchange dapat, atas
      kebijakannya sendiri, memperbarui biaya tersebut pada setiap saat. Setiap
      biaya yang diperbarui akan berlaku untuk setiap penjualan atau Transaksi
      lain yang terjadi setelah tanggal efektif biaya yang diperbarui. Anda
      memberi wewenang kepada Pegasus Exchange untuk memotong dari akun anda
      semua biaya yang berlaku yang terutang berdasarkan Syarat dan Ketentuan
      ini.
    </p>
    <h1 class="text_h">V. Kewajiban</h1>
    <h2 class="text_h">1. Pernyataan Pengecualian Terhadap Garansi</h2>
    <p class="p1">
      Sejauh yang diizinkan berdasarkan hukum dan peraturan perundang-undangan
      yang berlaku, Layanan Pegasus Exchange, materi Pegasus Exchange dan
      produk, layanan, atau barang lain apa pun yang disediakan oleh atau atas
      nama Pegasus Exchange ditawarkan atas dasar "sebagaimana adanya" dan
      "sebagaimana tersedia", akan tetapi Pegasus Exchange secara tegas menolak,
      dan anda mengesampingkan, setiap dan semua garansi lain dalam bentuk apa
      pun, baik tersurat maupun tersirat, termasuk, tanpa batasan, garansi dapat
      diperjualbelikan, kesesuaian untuk tujuan tertentu, hak milik atau
      non-pelanggaran atau garansi yang timbul dari pelaksanaan, kursus dari
      berurusan atau Penggunaan dalam perdagangan. Tanpa membatasi hal di atas,
      Pegasus Exchange tidak menyatakan atau menjamin bahwa situs web, layanan
      Pegasus Exchange atau materi Pegasus Exchange akurat, lengkap, dapat
      diandalkan, terkini, bebas dari kesalahan, atau bebas dari virus atau
      komponen berbahaya lainnya. Pegasus Exchange tidak menjamin bahwa setiap
      Pesanan (Order) yang ada akan dieksekusi, diterima, dicatat atau tetap
      terbuka. Kecuali untuk pernyataan tegas, perjanjian dan aturan yang
      ditetapkan dalam Syarat dan Ketentuan ini, anda dengan ini mengakui dan
      setuju bahwa anda tidak bergantung pada pernyataan atau perjanjian
      lain,baik tertulis atau lisan, sehubungan dengan Penggunaan dan akses anda
      atas Layanan Pegasus Exchange.
    </p>
    <p class="p1">
      Tanpa membatasi hal-hal di atas, anda dengan ini memahami dan menyetujui
      bahwa Pegasus Exchange tidak bertanggung jawab atas segala kerugian atau
      kerusakan yang timbul dari atau terkait dengan: (a) ketidakakuratan, cacat
      atau kelalaian data harga aset digital; (b) kesalahan atau keterlambatan
      pengiriman data tersebut; (c) gangguan pada data tersebut; (d)
      pemeliharaan rutin atau tidak terjadwal yang dilakukan oleh Pegasus
      Exchange dan gangguan serta perubahan layanan yang diakibatkan oleh
      pemeliharaan tersebut; (e) segala kerusakan yang ditimbulkan oleh tindakan
      Konsumen lain,kelalaian atau pelanggaran ketentuan ini; (f) segala
      kerusakan yang disebabkan oleh tindakan ilegal pihak ketiga lainnya atau
      tindakan tanpa izin dari Pegasus Exchange; dan (g) pengecualian lain yang
      disebutkan dalam sangkalan dan aturan platform yang dikeluarkan oleh
      Pegasus Exchange.
    </p>
    <p class="p1">
      Pernyataan pengecualian terhadap garansi tersirat yang terkandung di dalam
      ketentuan ini mungkin tidak berlaku jika dan sejauh dilarang oleh hukum
      dan peraturan perundang-undangan Republik Indonesia yang berlaku.
    </p>
    <h2 class="text_h">
      2. Pernyataan mengenai Kerusakan dan Pembatasan Tanggung Jawab
    </h2>
    <p class="p1">
      Sejauh diizinkan oleh hukum dan peraturan perundang-undangan yang berlaku,
      Pegasus Exchange, yang mencakup para afiliasi dan pemegang saham, anggota,
      Direktur, pejabat, karyawan, pengacara, agen, perwakilan, pemasok, atau
      kontraktor masing-masing tidak bertanggung jawab atas ganti rugi atau
      pertanggungjawaban insidental, tidak langsung, khusus, bersifat menghukum,
      konsekuensial (consequential) atau serupa (termasuk, tanpa batasan, ganti
      rugi atas hilangnya data, informasi, pendapatan, keuntungan atau bisnis
      lain atau keuntungan finansial) yang timbul dari Layanan Pegasus Exchange
      Indonesia, kinerja atau non-kinerja Layanan Pegasus Exchange, atau produk,
      layanan, atau barang lain apa pun yang disediakan oleh atau atas nama
      Pegasus Exchange dan afiliasinya, baik berdasarkan kontrak, undang-undang,
      tanggung jawab ketat, atau teori lain bahkan jika Pegasus Exchange telah
      diberitahu tentang kemungkinan kerusakan tersebut, kecuali sejauh putusan
      pengadilan akhir bahwa kerusakan tersebut adalah akibat dari kelalaian,
      penipuan, kesalahan yang disengaja atau pelanggaran hukum yang disengaja
      oleh Pegasus Exchange. Beberapa yurisdiksi tidak mengizinkan pengecualian
      atau pembatasan ganti rugi insidental atau konsekuensial (consequential),
      sehingga pembatasan di atas mungkin tidak berlaku untuk anda.
    </p>
    <p class="p1">
      Tanpa mengesampingkan ketentuan yang di atas, dalam keadaan apa pun
      Pegasus Exchange, yang mencakup para afiliasi, dan pemegang saham,
      anggota, direktur, pejabat, karyawan, pengacara, agen, perwakilan,
      pemasok, atau kontraktornya masing-masing tidak akan bertanggung jawab
      dari layanan yang timbul yang ditawarkan oleh atau atas nama Pegasus
      Exchange dan afiliasinya, setiap kinerja atau non-kinerja Layanan Pegasus
      Exchange, atau produk, layanan, atau barang lain apa pun, baik berdasarkan
      kontrak, undang-undang, tanggung jawab mutlak, atau teori lainnya,
      melebihi jumlah biaya yang anda bayarkan kepada Pegasus Exchange
      berdasarkan Syarat dan Ketentuan ini dalam periode dua belas bulan segera
      sebelum peristiwa yang menimbulkan klaim untuk ganti rugi.
    </p>
    <h2 class="text_h">3. Ganti Rugi</h2>
    <p class="p1">
      Anda setuju untuk mengganti kerugian dan membebaskan Pegasus Exchange,
      serta afiliasi, kontraktor, pemberi lisensi, dan direktur, pejabat,
      karyawan, dan agen Pegasus Exchange masing-masing dari dan terhadap klaim,
      tindakan, proses, investigasi, tuntutan, tuntutan, biaya, pengeluaran, dan
      kerusakan (termasuk biaya pengacara, denda atau hukuman yang dikenakan
      oleh otoritas pengatur) yang timbul dari atau terkait dengan (i)
      Penggunaan anda atas, atau perilaku sehubungan dengan, Layanan Pegasus
      Exchange, (ii) pelanggaran anda atau penegakan Syarat dan Ketentuan ini
      oleh kami, atau (iii) pelanggaran anda terhadap hukum, peraturan, atau hak
      yang berlaku dari pihak ketiga mana pun selama anda menggunakan Layanan
      Pegasus Exchange. Apabila anda berkewajiban untuk mengganti kerugian
      Operator Pegasus Exchange, afiliasinya, kontraktor, pemberi lisensinya,
      dan direktur, pejabat, karyawan atau agennya masing-masing sesuai dengan
      Syarat dan Ketentuan ini, Pegasus Exchange berhak, atas kebijakannya
      sendiri, untuk mengontrol tindakan atau proses apa pun dan untuk
      menentukan apakah Pegasus Exchange ingin menyelesaikan, dan jika demikian,
      dengan syarat yang ditentukannya.
    </p>
    <h1 class="text_h">VI. Pengumuman dan Pemberitahuan</h1>
    <p class="p1">
      Perlu diketahui bahwa semua pengumuman resmi, pemberitahuan, berita,
      promosi, kompetisi, dan airdrop akan dicantumkan di
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >. Konsumen berjanji untuk merujuk ke materi ini secara teratur dan
      segera. Pegasus Exchange tidak akan bertanggung jawab atau bertanggung
      jawab dalam bentuk kompensasi apa pun jika Konsumen mengalami kerugian
      pribadi yang timbul dari ketidaktahuan atau kelalaian pengumuman tersebut.
    </p>
    <h1 class="text_h">VII. Pengakhiran Perjanjian</h1>
    <h2 class="text_h">1. Penangguhan Akun Pegasus Exchange Indonesia</h2>
    <p class="p1">
      Anda menyetujui bahwa Pegasus Exchange memiliki hak untuk segera
      memberhentikan Akun Pegasus Exchange anda, membekukan atau mengunci Aset
      Keuangan Digital atau dana dalam akun tersebut, dan menangguhkan akses
      anda terhadap Pegasus Exchange dikarenakan suatu sebab apa pun termasuk
      jika Pegasus Exchange menduga akun tersebut melakukan pelanggaran terhadap
      Syarat dan Ketentuan ini, Kebijakan Privasi kami, atau segala hukum dan
      peraturan perundang-undangan yang berlaku. Anda menyetujui bahwa Pegasus
      Exchange tidak akan bertanggung jawab kepada anda atas segala modifikasi
      permanen atau sementara pada akun Pegasus Exchange anda, atau penangguhan
      atau pengakhiran akses anda terhadap semua atau sebagian dari Layanan
      Pegasus Exchange. Pegasus Exchange berhak untuk menyimpan dan menggunakan
      data Transaksi atau informasi lainnya yang terkait dengan akun Pegasus
      Exchange tersebut. Kontrol akun di atas juga dapat diaplikasi dalam
      kasus-kasus berikut:
    </p>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">a.</span> Akun Pegasus Exchange tersebut terlibat
        dalam sebuah acara pemerintahan, pemeriksaan pidana atau proses
        pengadilan lainnya;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">b.</span> Kami mendeteksi aktivitas yang tidak
        biasa dalam Akun Pegasus Exchange;
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">c.</span> Kami mendeteksi akses tidak sah
        terhadap Akun Pegasus Exchange; dan
      </li>
    </ul>
    <ul class="ul-letter">
      <li class="li-letter">
        <span class="li-label">d.</span> Kami wajib melakukannya atas perintah
        pengadilan atau perintah oleh otoritas pengaturan/pemerintah.
      </li>
    </ul>
    <h2 class="text_h">2. Pembatalan Akun Pegasus Exchange</h2>
    <p class="p1">
      Dalam kasus peristiwa-peristiwa berikut, Pegasus Exchange berhak untuk
      mengakhiri Syarat dan Ketentuan ini secara langsung dengan membatalkan
      Akun Pegasus Exchange anda, dan akan menikmati hak tetapi bukan kewajiban
      untuk membekukan (membatalkan) otorisasi Akun Pegasus Exchange anda
      terhadap Pegasus Exchange dan menarik Akun Pegasus Exchange yang sesuai:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">
        setelah Pegasus Exchange mengakhiri pelayanannya terhadap anda;
      </li>
      <li class="li-sub">
        anda kembali tertuduh meregistrasi atau meregistrasi dalam nama orang
        lain sebagai Konsumen Pegasus Exchange, secara langsung atau tidak
        langsung;
      </li>
      <li class="li-sub">
        informasi yang anda sediakan tidak jujur, tidak akurat, usang, atau
        tidak lengkap;
      </li>
      <li class="li-sub">
        pada waktu Syarat dan Ketentuan ini diubah, anda menyatakan ketidakmauan
        anda untuk menerima Syarat dan Ketentuan yang diubah dengan mengajukan
        pembatalan Akun Pegasus Exchange anda atau dengan cara lainnya;
      </li>
      <li class="li-sub">
        anda meminta Layanan Pegasus Exchange diberhentikan; dan
      </li>
      <li class="li-sub">
        keadaan apa pun di mana Pegasus Exchange menganggap bahwa seharusnya
        Layanan Pegasus Exchange diakhiri.
      </li>
    </ul>
    <p class="p1">
      Jika Akun Pegasus Exchange anda diakhiri, akun dan informasi Transaksi
      yang memenuhi standar retensi data akan disimpan secara aman selama 5
      tahun. Selain itu, jika sebuah Transaksi tidak selesai selama proses
      pengakhiran akun, Pegasus Exchange berhak untuk memberitahukan rekanan
      (counterparty) anda tentang situasi pada saat itu. Anda mengakui bahwa
      sebuah pengeluaran dari akun yang diinisiasikan oleh Konsumen juga akan
      tunduk pada protokol pengakhiran yang disebut di atas.
    </p>
    <p class="p1">
      Jika Pegasus Exchange diinformasikan bahwa suatu Aset Keuangan Digital
      atau dana yang disimpan di Akun Pegasus Exchange anda dicuri atau tidak
      secara sah dimiliki oleh anda, Pegasus Exchange dapat, tetapi tidak
      mempunyai kewajiban untuk, menerapkan penangguhan administratif terhadap
      dana yang terdampak dan Akun Pegasus Exchange anda. Jika Pegasus Exchange
      menerapkan penahanan administratif atas sebagian atau seluruh dana anda
      atau Akun Pegasus Exchange, Pegasus Exchange dapat melanjutkan penangguhan
      administratif tersebut sampai suatu waktu di mana sengketa telah
      diselesaikan dan bukti mengenai penyelesaian sengketa yang dapat diterima
      oleh Pegasus Exchange telah diberikan kepada Pegasus Exchange dalam bentuk
      yang dapat diterima oleh Pegasus Exchange. Pegasus Exchange tidak akan
      terlibat dalam sengketa atau penyelesaian sengketa. Anda menyetujui bahwa
      Pegasus Exchange tidak bertanggung jawab atas segala penangguhan atau atas
      ketidakmampuan anda untuk menarik Aset Keuangan Digital atau dana atau
      melakukan perdagangan selama periode penangguhan.
    </p>
    <h2 class="text_h">
      3. Sisa Dana Setelah Pengakhiran Akun Pegasus Exchange Dikarenakan
      Penipuan, Penyimpangan Hukum, atau Penyimpangan Syarat dan Ketentuan
    </h2>
    <p class="p1">
      Pegasus Exchange mempertahankan kepemilikan penuh atas Aset Keuangan
      Digital dan Informasi Pribadi Konsumen yang dapat diserahkan kepada
      otoritas pemerintah dalam kejadian penangguhan/penutupan Akun Pegasus
      Exchange yang timbul dari pemeriksaan penipuan, pemeriksaan penyimpangan
      hukum atau penyimpangan Syarat dan Ketentuan ini.
    </p>
    <h2 class="text_h">4. Akun Tidak Aktif</h2>
    <p class="p1">
      Tanpa mengesampingkan ketentuan apa pun dalam Bagian VII ini, Pegasus
      Exchange dapat menyediakan sebuah pemberitahuan tertulis yang memerlukan
      anda untuk membuka semua posisi dan menarik semua Aset Digital anda dari
      Akun Pegasus Exchange anda dalam waktu 30 (tiga puluh) hari pemberitahuan.
      Jika anda gagal untuk melakukan hal tersebut, Pegasus Exchange dapat dalam
      kewenangan mutlaknya dan tanpa pemberitahuan sebelumnya terhadap anda:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">
        menganggap Akun Pegasus Exchange anda sebagai akun tidak aktif;
      </li>
      <li class="li-sub">
        menutup segala posisi terbuka dalam produk Pegasus Exchange Indonesia;
      </li>
      <li class="li-sub">
        mengonversi Aset Digital menjadi Aset Digital tipe lainnya (mis., mulai
        dari BTC hingga USDT). Untuk menghindari keraguan, Pegasus Exchange
        tidak akan bertanggung jawab atas segala kehilangan pendapatan,
        kewajiban pajak atau segala kerugian, kerusakan atau pengeluaran yang
        timbul dari konversi tersebut;
      </li>
      <li class="li-sub">
        mengalihkan akun yang tidak aktif (termasuk segala Aset Digital yang
        terkandung di dalamnya) kepada suatu afiliasi Pegasus Exchange
        Indonesia, kustodian pihak ketiga apa pun atau suatu Dompet (Wallet)
        yang terisolasi di mana telah dianggap cukup diperlukan untuk dilakukan
        oleh Pegasus Exchange. Dalam kejadian di mana pemindahan tersebut telah
        terjadi, anda memiliki hak untuk menerima Aset Digital, tunduk pada
        pemenuhan persyaratan verifikasi Pegasus Exchange Indonesia, termasuk
        menyelesaikan KYC;
      </li>
      <li class="li-sub">
        mengenakan biaya akun tidak aktif untuk menutupi biaya pertahanan
        aset-aset oleh Pegasus Exchange, afiliasinya, atau pihak ketiga apa pun
        dan biaya tersebut akan ditarik langsung dari akun yang tidak aktif
        setiap bulan; dan
      </li>
      <li class="li-sub">
        menutup sebuah akun tidak aktif setiap saat, dan Pegasus Exchange tidak
        akan bertanggung jawab atas kerugian, kerusakan atau biaya yang
        dikeluarkan oleh anda sebagai akibat dari penutupan akun yang tidak
        aktif kecuali terdapat penipuan atau wanprestasi yang disengaja oleh
        Pegasus Exchange. Setiap aset dalam akun yang tidak aktif ini akan
        dialihkan sesuai dengan ayat iv di atas. Setelah sebuah akun yang tidak
        aktif ditutup, akun tersebut tidak dapat diaktifkan kembali oleh anda
        (yaitu anda perlu mendaftarkan Akun Pegasus Exchange yang baru jika anda
        ingin tetap menggunakan Layanan Pegasus Exchange .
      </li>
    </ul>
    <h2 class="text_h">5. Tidak Ada Nasihat Finansial</h2>
    <p class="p1">
      Pegasus Exchange tidak memiliki peran dan fungsi sebagai pialang (broker),
      perantara, agen atau penasihat anda dan tidak memiliki hubungan
      kepercayaan atau kewajiban kepada anda sehubungan dengan segala pedagang
      atau keputusan lainnya atau aktivitas yang terdampak dengan anda
      menggunakan Layanan Pegasus Exchange. Tidak ada komunikasi atau informasi
      yang diberikan kepada anda oleh Pegasus Exchange yang dimaksudkan sebagai,
      atau dianggapi atau ditafsirkan sebagai, nasihat investasi, nasihat
      keuangan, nasihat perdagangan, atau nasihat lainnya. Kecuali ditentukan
      lain dalam Syarat dan Ketentuan ini, semua perdagangan dieksekusi secara
      otomatis, berdasarkan parameter perintah instruksi Pesanan (Order) anda
      dan sesuai dengan prosedur pelaksanaan perdagangan yang ditetapkan, dan
      anda bertanggung jawab penuh untuk menentukan apakah investasi, strategi
      investasi atau Transaksi terkait sesuai untuk anda sesuai dengan tujuan
      investasi pribadi anda, keadaan finansial dan toleransi risiko (risk
      tolerance), dan anda bertanggung jawab penuh atas segala kerugian atau
      kewajiban apa pun darinya. Anda sebaiknya berkonsultasi dengan ahli hukum
      atau pajak mengenai keadaan khusus anda. Pegasus Exchange tidak
      merekomendasikan Aset Digital apa pun untuk dibeli, diperoleh, dijual,
      atau ditahan oleh anda. Sebelum mengambil keputusan untuk membeli,
      menjual, atau menahan Aset Digital apa pun, anda sebaiknya melakukan uji
      tuntas sendiri dan berkonsultasi dengan penasihat finansial anda sebelum
      membuat keputusan investasi apa pun. Pegasus Exchange tidak akan
      bertanggung jawab atas keputusan anda untuk membeli, menjual, atau menahan
      Aset Digital berdasarkan informasi yang disediakan oleh Pegasus Exchange
      Indonesia.
    </p>
    <h1 class="text_h">VIII. Kepatuhan dengan Undang-undang Setempat</h1>
    <p class="p1">
      Adalah tanggung jawab para Konsumen untuk mematuhi undang-undang setempat
      terkait dengan Penggunaan Layanan Pegasus Exchange yang sah dalam
      yurisdiksi setempat serta hukum dan peraturan perundang-undangan lainnya
      yang berlaku terhadap para Konsumen. Konsumen juga harus memperhitungkan,
      sejauh hukum setempat mereka, segala aspek mengenai perpajakan,
      pemotongan, pengumpulan, pelaporan dan pengiriman uang terhadap otoritas
      pajak yang sesuai.
    </p>
    <p class="p1">
      Semua Konsumen Layanan Pegasus Exchange mengakui dan menyatakan bahwa dana
      mereka berasal dari sumber yang sah dan tidak berasal dari kegiatan
      ilegal. Konsumen setuju bahwa Pegasus Exchange akan meminta mereka untuk
      menyediakan atau mengumpulkan informasi dan materi yang diperlukan sesuai
      dengan hukum dan peraturan perundang-undangan yang relevan atau perintah
      oleh pemerintah untuk memverifikasi legalitas atas sumber dan Konsumen
      dana mereka.
    </p>
    <p class="p1">
      Pegasus Exchange mempertahankan sikap kerja sama dengan otoritas penegak
      hukum secara global dan tidak akan ragu untuk menyita, membekukan,
      menangguhkan dan mengakhiri akun dan dana para Konsumen yang ditandai atau
      diperiksa oleh mandat hukum.
    </p>
    <h1 class="text_h">IX. Kebijakan Privasi</h1>
    <p class="p1">
      Akses terhadap Layanan Pegasus Exchange akan memerlukan penyerahan
      informasi pengenal pribadi tertentu.
    </p>
    <p class="p1">
      Harap membaca Kebijakan Privasi Pegasus Exchange
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
      untuk panduan lengkap dari Pegasus Exchange tentang pengumpulan dan
      Penggunaan informasi pengenal pribadi.
    </p>
    <h1 class="text_h">X. Informasi Rahasia</h1>
    <p class="p1">
      Setiap informasi dan/atau data yang diberikan oleh Pegasus Exchange kepada
      Konsumen dan atau data yang diperoleh Konsumen sebagai pelaksanaan dari
      Syarat dan Ketentuan dan/atau perjanjian lainnya seperti Kebijakan
      Privasi, baik yang diberikan atau disampaikan secara lisan, tertulis,
      grafik atau yang disampaikan melalui media elektronik atau informasi dan
      atau data dalam bentuk lainnya selama berlangsungnya pembicaraan atau
      selama pekerjaan lain dianggap bersifat rahasia (selanjutnya disebut
      sebagai "Informasi Rahasia").
    </p>
    <p class="p1">
      Konsumen setuju dan sepakat bahwa setiap saat akan merahasiakan Informasi
      Rahasia yang diperoleh sebagai pelaksanaan dari kerja sama kepada siapa
      pun atau tidak akan menggunakannya untuk kepentingan Konsumen atau
      kepentingan pihak lainnya, tanpa terlebih dahulu memperoleh persetujuan
      tertulis dari pejabat yang berwenang dari Pegasus Exchange atau pihak yang
      berwenang lainnya sesuai dengan ketentuan hukum dan peraturan
      perundang-undangan yang berlaku.
    </p>
    <p class="p1">
      Apabila Konsumen melanggar ketentuan sebagaimana dimaksud di atas mengenai
      ketentuan kerahasiaan ini, maka segala kerugian, tuntutan dan atau gugatan
      yang dialami Pegasus Exchange merupakan tanggung jawab Konsumen
      sepenuhnya, dan atas permintaan pertama dari Pegasus Exchange, Konsumen
      berkewajiban untuk menyelesaikannya sesuai dengan ketentuan hukum dan
      peraturan perundang-undangan yang berlaku dan memberikan ganti rugi yang
      mungkin timbul akibat pelanggaran tersebut kepada Pegasus Exchange.
      Konsumen dengan ini setuju bahwa Pegasus Exchange tidak akan memberikan
      ganti rugi dan atau pertanggungjawaban dalam bentuk apa pun kepada
      Konsumen atau pihak mana pun atas segala tuntutan dan atau gugatan yang
      mungkin timbul dikemudian hari sehubungan dengan pelanggaran tersebut.
    </p>
    <p class="p1">
      Kewajiban untuk menyimpan Informasi Rahasia sebagaimana dimaksud di atas
      dalam ketentuan mengenai kerahasiaan menjadi tidak berlaku, apabila:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">
        Informasi Rahasia tersebut menjadi tersedia untuk masyarakat umum.
        Informasi Rahasia tersebut diperintahkan untuk dibuka untuk memenuhi
        perintah pengadilan atau badan pemerintahan lain yang berwenang.
        Informasi Rahasia tersebut diberikan sesuai ketentuan hukum dan
        peraturan perundang-undangan yang berlaku.
      </li>
      <li class="li-sub">
        Konsumen selanjutnya menyetujui untuk melakukan segenap upaya dan
        mengambil setiap tindakan yang diperlukan untuk menghindari pihak-
        ketiga dalam memperoleh akses terhadap atau mengakibatkan terjadinya
        pengungkapan atas Informasi Rahasia.
      </li>
    </ul>
    <p class="p1">
      Ketentuan Informasi Rahasia yang ditetapkan dalam bagian ini akan tetap
      berlaku kepada Konsumen dan Pegasus Exchange setelah pengakhiran Syarat
      dan Ketentuan ini.
    </p>
    <h1 class="text_h">XI. Kekayaan Intelektual</h1>
    <p class="p1">
      Konsumen menyatakan dan menyetujui bahwa Pegasus Exchange adalah pemegang
      hak kepemilikan atas layanan, perangkat lunak, alat teknologi dan konten,
      situs, dan bahan lain termasuk Hak Kekayaan Intelektual yang terkait
      dengan Layanan Pegasus Exchange.
    </p>
    <p class="p1">
      Konsumen hanya diperbolehkan untuk melihat, mencetak dan/atau mengunduh
      material dari Platform Pegasus Exchange untuk Penggunaan pribadi dan
      non-komersial. Seluruh Penggunaan komersial perlu mendapatkan izin dari
      Pegasus Exchange Indonesia. Setiap kegiatan komersial tanpa seizin Pegasus
      Exchange diartikan sebagai pelanggaran atas Hak Kekayaan Intelektual
      Pegasus Exchange dan mengakibatkan pemberhentian Akun Pegasus Exchange
      yang dimiliki Konsumen.
    </p>
    <h1 class="text_h">XII. Pemberitahuan dan Pernyataan Risiko</h1>
    <p class="p1">
      Konsumen mengakui adanya kemungkinan risiko yang terkait dengan Penggunaan
      Layanan Pegasus Exchange. Risiko kerugian dalam perdagangan atau memegang
      Aset Keuangan Digital mungkin cukup besar. Oleh karena itu, Konsumen harus
      mempertimbangkan dengan hati-hati apakah perdagangan atau memegang Aset
      Keuangan Digital sesuai dengan kondisi finansial pribadi.
    </p>
    <p class="p1">
      Konsumen mengakui bahwa risiko tambahan mungkin timbul dalam Penggunaan
      Layanan Pegasus Exchange Indonesia, seperti fluktuasi harga, kegagalan
      sistem dan risiko terkait lainnya. Pegasus Exchange tidak akan bertanggung
      jawab atas segala kehilangan yang timbul dari risiko di luar pengendalian
      Pegasus Exchange Indonesia.
    </p>
    <p class="p1">
      Konsumen dapat merujuk kepada Perjanjian Konsumen untuk Dokumen
      Pemberitahuan Risiko dan Pernyataan yang lengkap, sebagaimana dapat
      diakses melalui
      <a
        href="https://pegasusexchange.id/"
        target="_blank"
        rel="noopener noreferrer"
        >https://pegasusexchange.id/</a
      >
    </p>
    <h1 class="text_h">XIII. Keamanan Sistem</h1>
    <p class="p1">
      Pegasus Exchange telah menerapkan jaringan dan tindakan keamanan sebagai
      jaringan pengaman informasi terhadap akses yang tidak sah dalam
      Penggunaan, perubahan dan/atau pengungkapan Akun Pegasus Exchange, dengan
      standar keamanan yang telah disesuaikan dengan ketentuan hukum dan
      peraturan perundang-undangan yang berlaku. Masuknya pihak yang tidak
      bertanggung jawab terhadap akses dalam Penggunaan, perubahan dan/atau
      pengungkapan akun dari pihak ketiga yang mengakibatkan kelalaian dan/atau
      kesalahan Konsumen berakibat ditanggungnya risiko oleh Konsumen, maka
      Pegasus Exchange tidak akan memberikan ganti rugi dan atau
      pertanggungjawaban dalam bentuk apa pun kepada Konsumen atau pihak lain
      mana pun atas segala risiko, tanggung jawab dan tuntutan apa pun yang
      mungkin timbul sehubungan dengan adanya kelalaian, kesengajaan, dan/atau
      kesalahan Konsumen dalam memberikan informasi.
    </p>
    <h1 class="text_h">
      XIV. Penyelesaian Sengketa: Forum, Arbitrase, Pelepasan Class Action
    </h1>
    <h2 class="text_h">1. Surat Tuntutan dan Periode Penyelesaian Sengketa</h2>
    <p class="p1">
      Dalam kejadian adanya tuntutan atau permasalahan, mohon menghubungi
      Pegasus Exchange. Pegasus Exchange ingin mengatasi kekhawatiran anda tanpa
      menggunakan proses hukum formal, jika memungkinkan. Jika anda memiliki
      perselisihan dengan Pegasus Exchange, maka anda harus menghubungi Pegasus
      Exchange dan nomor tiket akan diberikan. Pegasus Exchange akan berusaha
      untuk menyelesaikan sengketa anda secara internal (yang selambat-lambatnya
      tidak akan melebihi 60 hari kerja dari penerimaan pengaduan anda). Para
      pihak setuju untuk bernegosiasi secara itikad baik untuk menyelesaikan
      perselisihan (yang diskusi akan tetap rahasia dan tunduk pada peraturan
      yang berlaku yang melindungi diskusi penyelesaian sengketa dari Penggunaan
      sebagai bukti dalam proses hukum apa pun).
    </p>
    <p class="p1">
      Dalam hal perselisihan tidak dapat diselesaikan secara memuaskan, dan anda
      ingin mengajukan tuntutan terhadap Pegasus Exchange, maka anda untuk
      mengajukan dasar atas tuntutan tersebut secara tertulis dalam suatu "Surat
      Tuntutan" sebagai bentuk dari pemberitahuan sebelumnya terhadap Pegasus
      Exchange. Surat Tuntutan harus (1) menjelaskan sifat dan dasar dari
      tuntutan atau sengketa (2) menyatakan penyelesaian yang diinginkan, (3)
      memberikan nomor tiket yang asli, dan (4) mencantumkan email Akun Pegasus
      Exchange anda. Surat Tuntutan tersebut harus disampaikan kepada alamat
      email atau hyperlink yang disediakan dalam korespondensi anda dengan
      Pegasus Exchange. Setelah anda memberikan Surat Tuntutan kepada Pegasus
      Exchange, sengketa yang dirujuk dalam Surat Tuntutan dapat disampaikan
      oleh Pegasus Exchange atau anda kepada arbitrase. Untuk menghindari
      keraguan, pengajuan sengketa kepada Pegasus Exchange untuk penyelesaian
      internal dan penyampaian Surat Tuntutan kepada Pegasus Exchange merupakan
      prasyarat untuk melaksanakan proses arbitrase (atau segala proses hukum
      lainnya). Selama proses arbitrase, jumlah segala pembayaran yang
      ditawarkan oleh anda atau Pegasus Exchange tidak akan diungkapkan kepada
      arbiter.
    </p>
    <h2 class="text_h">
      2. Kesepakatan untuk Arbitrase dan Hukum yang Berlaku
    </h2>
    <p class="p1">
      Anda dan Pegasus Exchange setuju bahwa segala sengketa, tuntutan, atau
      kontroversi antara anda dan Pegasus Exchange yang timbul sehubungan dengan
      atau yang berkaitan bagaimanapun dengan Syarat dan Ketentuan ini atau
      hubungan anda dengan Pegasus Exchange sebagai Konsumen dari Layanan
      Pegasus Exchange (baik berdasarkan kontrak, perbuatan melawan hukum,
      peraturan, penipuan, kesalahan pernyataan atau segala teori hukum lainnya,
      dan apakah tuntutan timbul saat atau setelah pengakhiran Syarat dan
      Ketentuan ini) akan ditentukan oleh arbitrase per individu (bukan
      kelas/class) yang sah dan mengikat, kecuali sebagaimana diatur di bawah
      dalam pengecualian terhadap perjanjian arbitrase. Anda dan Pegasus
      Exchange selanjutnya menyetujui bahwa arbiter akan mempunyai kekuasaan
      khusus untuk menguasai yurisdiksinya, termasuk namun tidak terbatas pada
      setiap keberatan sehubungan dengan keberadaan, ruang lingkup atau
      keabsahan perjanjian arbitrase, atau kemungkinan untuk melakukan arbitrase
      atas tuntutan atau gugatan balik. Arbitrase lebih informal daripada
      gugatan di pengadilan. Arbiter harus mengikuti perjanjian ini dan dapat
      memberikan ganti rugi dan keringanan yang sama seperti di pengadilan
      (termasuk, jika berlaku, biaya kuasa hukum), kecuali bahwa arbiter tidak
      dapat memberikan keputusan deklaratoir atau penyelesaian berdasarkan
      putusan yang mendukung siapa pun kecuali para pihak dalam arbitrase.
      Ketentuan arbitrase yang ditetapkan dalam bagian ini akan tetap berlaku
      setelah pengakhiran Syarat dan Ketentuan ini.
    </p>
    <h2 class="text_h">3. Arbitrase</h2>
    <p class="p1">
      Arbitrase akan diselesaikan oleh Badan Arbitrase Nasional Indonesia (“
      BANI ”). Arbitrase akan dikelola oleh BANI. Kecuali para pihak menyetujui
      lainnya, hanya akan ada satu arbiter yang ditunjuk sesuai dengan Peraturan
      BANI. Setiap arbitrase akan dilaksanakan dalam Bahasa yang disepakati.
      Terlepas dari cara arbitrase akan dilakukan, arbiter akan mengeluarkan
      suatu keputusan tertulis yang cukup untuk menjelaskan temuan dan
      kesimpulan penting yang menjadi dasar keputusan, jika ada.
    </p>
    <p class="p1">
      Setiap arbitrase terhadap Pegasus Exchange harus dilakukan setelah
      mengajukan permohonan arbitrase dalam waktu 1 (satu) tahun, setelah
      tanggal di mana pihak yang mengajukan tuntutan pertama kali mengetahui
      atau seharusnya mengetahui tindakan, kelalaian, atau wanprestasi yang
      menimbulkan gugatan; dan tidak ada hak untuk upaya hukum apa pun atas
      tuntutan yang tidak diajukan dalam jangka waktu tersebut. Jangka waktu
      satu tahun ini termasuk prosedur penyelesaian perselisihan internal yang
      ditetapkan dalam paragraf di atas bagian ini. Tidak akan ada hak atas
      pemulihan apa pun untuk tuntutan apa pun yang tidak diajukan dalam jangka
      waktu tersebut. Jika hukum dan peraturan perundang-undangan yang berlaku
      melarang adanya periode pembatasan satu tahun untuk mengajukan tuntutan,
      segala tuntutan harus diajukan dalam waktu periode paling pendek yang
      diperbolehkan oleh hukum dan peraturan perundang-undangan yang berlaku.
    </p>
    <h2 class="text_h">4. Pemberitahuan</h2>
    <p class="p1">
      Pihak yang bermaksud untuk meminta arbitrase setelah berakhirnya periode
      penyelesaian sengketa sebagaimana dimaksud di atas, harus mengajukan
      permohonan kepada BANI sesuai dengan Peraturan BANI pada saat itu. Jika
      kami meminta arbitrase terhadap anda, kami akan memberikan anda
      pemberitahuan pada alamat email atau alamat surat yang anda berikan. Anda
      setuju bahwa setiap pemberitahuan yang dikirim ke email atau alamat surat
      tersebut akan dianggap efektif untuk semua tujuan, termasuk namun tidak
      terbatas pada penentuan kecukupan layanan. Adalah kewajiban anda untuk
      memastikan bahwa alamat email dan/atau alamat surat yang tercatat di
      Pegasus Exchange adalah yang terbaru dan akurat.
    </p>
    <h2 class="text_h">5. Tempat Kedudukan Arbitrase</h2>
    <p class="p1">
      Tempat kedudukan arbitrase akan berada di Jakarta, Indonesia. Lokasi
      sidang arbitrase secara langsung adalah di Jakarta, Indonesia, kecuali
      ditentukan lain oleh para pihak.
    </p>
    <h2 class="text_h">6. Hukum yang berlaku</h2>
    <p class="p1">
      Syarat dan Ketentuan ini (termasuk perjanjian arbitrase) diatur oleh, dan
      ditafsirkan sesuai dengan hukum negara Republik Indonesia. Para pihak
      menyetujui bahwa arbitrase harus dijaga kerahasiaannya. Keberadaan
      arbitrase, segala informasi non-publik yang disediakan dalam arbitrase,
      dan setiap pengajuan, perintah atau keputusan yang dibuat dalam arbitrase
      tidak boleh diungkapkan kepada non-pihak mana pun kecuali pengadilan,
      BANI, para pihak, penasihatnya, ahli, para saksi, akuntan, dan auditor,
      perusahaan asuransi dan reasuransi, dan setiap orang lainnya yang
      diperlukan dalam pelaksanaan arbitrase. Tanpa mengesampingkan ketentuan di
      atas, suatu pihak dapat mengungkapkan Informasi Rahasia sejauh
      pengungkapan tersebut diperlukan untuk memenuhi suatu kewajiban hukum,
      melindungi atau mengejar hak yang sah secara hukum, atau memberlakukan
      atau menentang suatu keputusan dalam proses hukum yang sah. Ketentuan
      kerahasiaan ini akan tetap berlaku setelah pengakhiran Syarat dan
      Ketentuan ini dan arbitrase apa pun yang diajukan sesuai dengan Syarat dan
      Ketentuan ini.
    </p>
    <h2 class="text_h">
      7. Pelepasan Hak Gugatan Perwakilan Kelompok (Class Action)
    </h2>
    <p class="p1">
      Anda dan Pegasus Exchange setuju bahwa setiap tuntutan yang berkaitan
      dengan Syarat dan Ketentuan ini atau hubungan anda dengan Pegasus Exchange
      sebagai Konsumen Layanan Pegasus Exchange (baik berdasarkan kontrak,
      perbuatan melawan hukum, peraturan, penipuan, kesalahan pernyataan atau
      segala teori hukum lainnya, dan apakah tuntutan timbul selama atau setelah
      pengakhiran Syarat dan Ketentuan ini) harus diajukan terhadap pihak lain
      dalam arbitrase secara individual saja dan tidak sebagai penggugat atau
      anggota kelompok (class member) dalam gugatan kelompok (purported class)
      atau perwakilan yang diakui (representative action). Anda dan Pegasus
      Exchange selanjutnya setuju untuk melepaskan hak atas gugatan tersebut
      untuk didengar, atau diarbitrasekan sebagai tindakan kelompok (class),
      kolektif, representatif, atau private attorney general action, sejauh
      diperbolehkan oleh hukum dan peraturan perundang-undangan yang berlaku.
      Menggabungkan atau mengkonsolidasikan arbitrase individual menjadi satu
      arbitrase tidak diperbolehkan tanpa persetujuan dari semua pihak, termasuk
      Pegasus Exchange.
    </p>
    <h2 class="text_h">8. Modifikasi</h2>
    <p class="p1">
      Pegasus Exchange berhak untuk memperbarui, memodifikasi, merevisi,
      menangguhkan, atau membuat segala perubahan kedepannya terhadap Bagian XII
      terkait dengan persetujuan para pihak untuk perjanjian arbitrase, tunduk
      pada hukum dan peraturan perundang-undangan yang berlaku. Dengan ini anda
      menyetujui bahwa anda bertanggung jawab untuk memastikan bahwa pemahaman
      anda mengenai Bagian ini mutakhir. Tunduk pada hukum yang berlaku,
      Penggunaan berkelanjutan anda atas Akun Pegasus Exchange anda akan
      dianggap sebagai penerimaan anda atas segala modifikasi terhadap Bagian
      XII terkait dengan perjanjian arbitrase para pihak. Anda setuju bahwa jika
      anda keberatan dengan modifikasi yang dilakukan terhadap Bagian XII,
      Pegasus Exchange dapat memblokir akses terhadap akun anda saat menunggu
      penutupan akun anda. Dalam situasi tersebut, Syarat dan Ketentuan sebelum
      modifikasi akan tetap berlaku penuh dan berlaku sambil menunggu penutupan
      akun anda.
    </p>
    <h1 class="text_h">XV. Lain-lain</h1>
    <h2 class="text_h">1. Pihak Independen</h2>
    <p class="p1">
      Pegasus Exchange merupakan kontraktor independen tetapi bukan agen anda
      dalam pelaksanaan Syarat dan Ketentuan ini. Syarat dan Ketentuan ini tidak
      boleh ditafsirkan sebagai fakta atau bukti atas suatu asosiasi, usaha
      patungan, kemitraan, atau waralaba di antara para pihak.
    </p>
    <h2 class="text_h">2. Seluruh Perjanjian</h2>
    <p class="p1">
      Syarat dan Ketentuan ini merupakan keseluruhan perjanjian antara para
      pihak mengenai Penggunaan Layanan Pegasus Exchange dan akan menggantikan
      semua perjanjian tertulis atau lisan sebelumnya antara para pihak. Tidak
      ada Penggunaan perdagangan atau praktik reguler lainnya atau metode
      Transaksi antara para pihak akan digunakan untuk memodifikasi,
      menafsirkan, menambah, atau mengubah ketentuan di sini.
    </p>
    <h2 class="text_h">3. Interpretasi dan Revisi</h2>
    <p class="p1">
      Pegasus Exchange berhak untuk mengubah, merevisi, memodifikasi, dan/atau
      mengubah Syarat dan Ketentuan ini pada setiap saat. Semua perubahan akan
      berlaku segera setelah dipublikasikan di situs web Pegasus Exchange
      Indonesia. Anda bertanggung jawab untuk memeriksa halaman yang relevan di
      situs web/aplikasi kami secara reguler untuk mengonfirmasi versi terbaru
      dari Syarat dan Ketentuan ini. Jika anda tidak setuju dengan segala
      modifikasi tersebut, satu-satunya solusi anda adalah untuk menghentikan
      Penggunaan Layanan Pegasus Exchange dan membatalkan akun anda. Anda setuju
      bahwa, kecuali dinyatakan lain dalam Syarat dan Ketentuan ini, Pegasus
      Exchange tidak akan bertanggung jawab atas modifikasi atau penghentian
      Layanan Pegasus Exchange oleh anda atau pihak ketiga mana pun, atau
      penangguhan atau penghentian akses anda ke Layanan Pegasus Exchange.
    </p>
    <h2 class="text_h">4. Bahasa &amp; Terjemahan</h2>
    <p class="p1">
      Syarat dan Ketentuan ini dilaksanakan dalam bahasa Inggris dan bahasa
      Indonesia. Atas kebijaksanaan tunggal dan mutlak Pegasus Exchange, Syarat
      dan Ketentuan ini dapat diterjemahkan ke dalam bahasa selain bahasa
      Inggris. Anda setuju bahwa terjemahan tersebut hanya untuk kenyamanan anda
      dan teks bahasa Inggris akan berlaku jika ada ketidakjelasan, perbedaan
      atau kelalaian antara teks bahasa Inggris dan teks terjemahan apa pun.
    </p>
    <h2 class="text_h">5. Pajak</h2>
    <p class="p1">
      Bahwa pajak atas aktivitas perdagangan Aset Keuangan Digital adalah pajak
      yang ditanggung oleh masing-masing pelaku kegiatan, dalam hal ini Konsumen
      dan Pegasus Exchange. Konsumen dapat mengonsultasikan pembayaran pajak
      kepada Konsultan Pajak Pribadi, dan Pegasus Exchange tidak menanggung
      pajak Konsumen kecuali ditentukan lain dalam Syarat dan Ketentuan ini.
    </p>
    <h2 class="text_h">6. Keadaan Memaksa</h2>
    <p class="p1">
      Pegasus Exchange tidak akan bertanggung jawab atas keterlambatan atau
      kegagalan untuk pelaksanaan seperti yang dipersyaratkan oleh Syarat dan
      Ketentuan ini karena sebab atau kondisi apa pun di luar kendali wajar
      Pegasus Exchange.
    </p>
    <h2 class="text_h">7. Keterpisahan</h2>
    <p class="p1">
      Jika ada bagian dari Syarat dan Ketentuan ini yang dianggap tidak sah atau
      tidak dapat dilaksanakan, ketidakabsahan atau keberlakuan tersebut tidak
      akan memengaruhi Syarat dan Ketentuan lain dari persyaratan ini, yang akan
      tetap memiliki kekuatan dan efek penuh, dan bagian yang tidak sah atau
      tidak dapat dilaksanakan akan diberlakukan semaksimal mungkin.
    </p>
    <h2 class="text_h">8. Pemindahan</h2>
    <p class="p1">
      Anda tidak boleh memindahkan hak apapun untuk menggunakan Layanan Pegasus
      Exchange atau segala hak atau kewajiban anda berdasarkan Syarat dan
      Ketentuan ini tanpa persetujuan tertulis sebelumnya dari Pegasus Exchange,
      termasuk hak atau kewajiban apa pun yang terkait dengan penegakan hukum
      atau perubahan kendali. Pegasus Exchange dapat mengalihkan sebagian atau
      seluruh hak atau kewajibannya berdasarkan Syarat dan Ketentuan ini,
      seluruhnya atau sebagian, tanpa pemberitahuan atau memperoleh persetujuan
      anda.
    </p>
    <h2 class="text_h">9. Pelepasan Hak</h2>
    <p class="p1">
      Kegagalan salah satu pihak untuk menuntut pelaksanaan ketentuan apa pun
      tidak akan memengaruhi hak pihak tersebut untuk menuntut pelaksanaan
      setiap saat sesudahnya. Pada saat yang sama, pelepasan hak salah satu
      pihak untuk mencari pemulihan atas pelanggaran pihak lain terhadap Syarat
      dan Ketentuan ini atau ketentuan apa pun dari persyaratan yang berlaku
      tidak akan merupakan pelepasan hak oleh pihak tersebut atas pelanggaran
      atau pelanggaran berikutnya oleh pihak lain atau ketentuan tersebut
      sendiri.
    </p>
    <h2 class="text_h">10. Penolakan Situs Web Pihak Ketiga</h2>
    <p class="p1">
      Tautan apa pun ke situs web pihak ketiga dari Layanan Pegasus Exchange
      tidak menyiratkan dukungan oleh Pegasus Exchange atas produk, layanan,
      informasi, atau penolakan apa pun yang disajikan di dalamnya, dan Pegasus
      Exchange juga tidak menjamin keakuratan informasi yang terkandung di
      dalamnya. Jika anda menderita kerugian karena menggunakan produk dan
      layanan pihak ketiga tersebut, Pegasus Exchange tidak akan bertanggung
      jawab atas kerugian tersebut. Selain itu, karena Pegasus Exchange tidak
      memiliki kendali atas ketentuan Penggunaan atau kebijakan privasi situs
      web pihak ketiga, anda harus membaca dan memahami kebijakan tersebut
      dengan cermat.
    </p>
    <h2 class="text_h">
      11. Anti Pencucian Uang dan Pencegahan Pendanaan Terorisme
    </h2>
    <p class="p1">
      Syarat dan Ketentuan ini tunduk dan akan ditegakkan berdasarkan hukum dan
      peraturan perundang-undangan Indonesia, termasuk namun tidak terbatas,
      pada hal-hal berikut:
    </p>
    <ul class="ul-sub">
      <li class="li-sub">
        Undang-Undang No. 8 Tahun 2010 tentang Pencegahan dan Pemberantasan
        Tindak Pidana Pencucian Uang;
      </li>
      <li class="li-sub">
        Undang-Undang No. 9 Tahun 2013 tentang Pencegahan dan Pemberantasan
        Tindak Pidana Pendanaan Terorisme;
      </li>
      <li class="li-sub">
        Peraturan Kepala Pusat Pelaporan Analisis dan Transaksi Keuangan
        ("PPATK") No. PER-09/1.02.2/PPATK/09/12 tentang Tata Cara Penyampaian
        Laporan Transaksi Keuangan Mencurigakan dan Laporan Transaksi Keuangan
        Tunai bagi Penyedia Jasa Keuangan;
      </li>
      <li class="li-sub">
        Peraturan Kepala PPATK No. PER-12/1.02/PPATK/06/13 tentang Tata Cara
        Penyampaian Laporan Transaksi Keuangan Transfer Dana Dari dan Ke Luar
        Negeri bagi Penyedia Jasa Keuangan;
      </li>
      <li class="li-sub">
        Peraturan Kepala PPATK No. PER-02/1.02/PPATK/02/2014 tentang Sistem
        Informasi Konsumen Jasa Terpadu; dan
      </li>
      <li class="li-sub">
        Peraturan PPATK No. 2 Tahun 2021 tentang Tata Cara Penyampaian Laporan
        Transaksi Dan Laporan Transaksi Keuangan Mencurigakan Melalui Aplikasi
        GoAML Bagi Penyedia Barang Dan/atau Jasa.
      </li>
    </ul>
    <p class="p1">
      Oleh karenanya tunduk kepada kewajiban pelaporan kepada PPATK, serta
      menjalankan kewajiban pelaporan lainnya sebagaimana dipersyaratkan oleh
      hukum dan peraturan perundang-undangan yang berlaku.
    </p>
    <p class="p1">
      Untuk hal-hal yang belum diatur dalam Syarat dan Ketentuan, maka akan
      berlaku seluruh ketentuan dalam Kitab Undang-Undang Hukum Perdata
      Indonesia serta ketentuan-ketentuan hukum dan peraturan perundang-undangan
      lainnya yang terkait.
    </p>
    <h2 class="text_h">12. Komunikasi dan Pemberitahuan Elektronik</h2>
    <ul class="ul-sub">
      <li class="li-sub">
        anda dengan ini menyatakan setuju untuk melakukan seluruh bentuk
        komunikasi dengan Pegasus Exchange melalui sarana elektronik, termasuk
        namun tidak terbatas pada email, notifikasi pada Situs, atau media
        elektronik lainnya yang disediakan oleh Pegasus Exchange Indonesia; dan
      </li>
      <li class="li-sub">
        anda menyatakan setuju untuk menerima email dari Situs Pegasus Exchange
        ;
        <a
          href="https://pegasusexchange.id/"
          target="_blank"
          rel="noopener noreferrer"
          >https://pegasusexchange.id/</a
        >. E-mail yang dikirim dapat berisi informasi seputar Akun, transaksi,
        sistem, promosi dan lain sebagainya
      </li>
    </ul>
    <h2 class="text_h">13. Informasi Kontak</h2>
    <p class="p1">
      Jika anda memiliki pertanyaan atau keberatan mengenai Syarat dan Ketentuan
      ini anda, anda dapat menghubungi kami melalui:
    </p>
    <p class="p1">
      Email:
      <a href="mailto:corporateservice@pegasusexchange.id"
        >corporateservice@pegasusexchange.id</a
      >
    </p>
    <p class="p1">
      Kami akan menjawab pertanyaan atau masalah apa pun yang anda miliki
      sehubungan dengan Syarat dan Ketentuan ini.
    </p>
    <p class="p1 updated">
      <em>Terakhir Diperbarui pada tanggal 20/05/2025.</em>
    </p>
  </div>
</template>

<script>
// node_modules

// applibs

export default {
  components: {},
  data() {
    return {
      web_domain: "pegasusexchange.id",
    };
  },
};
</script>

<style scoped>
.text_h {
  margin-left: -20px;
  padding-top: 20px;
}
h2.head_txt {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 18pt;
}
.subtitle {
  font-weight: 600;
  margin-bottom: 1rem;
}
.updated {
  margin-top: 2rem;
  font-style: italic;
}
.p1 {
  margin-top: 14pt;
  margin-bottom: 14pt;
  text-align: justify;
  font-size: 16px;
}
.ul-letter,
.ul-sub {
  margin: 0 0 14pt 0;
  padding-left: 32pt;
  list-style: none;
}
.li-letter,
.li-sub {
  margin-top: 10pt;
  text-align: justify;
  font-size: 16px;
}
.li-label {
  font-weight: 600;
}
.text_h,
h1,
h2 {
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
}
.ctr_trm {
  max-width: 932px;
  padding: 0 20px;
  z-index: 995;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.head_txt {
  font-size: 28px;
  margin-left: -20px;
}
.ctr_trm a {
  color: #4da3ff;
  word-break: break-all;
}
@media (max-width: 500px) {
  .text_h,
  .head_txt,
  h1,
  h2 {
    font-size: 16px;
    margin-top: 20px;
  }
  .p1,
  .li-letter,
  .li-sub {
    font-size: 14px;
  }
}
</style>
